import loadable from '@loadable/component';
import Loading from '../../components/Loader';
import { State } from '../../reducers';
import { fetchAdvertiseRecommendations } from '../../actions/advertise';
import { fetchLocationToPostcode } from '../../actions/location';
import { fetchCategoryFromKey } from '../../actions/category';
import { fetchModalQuestions } from '../../actions/questions';

const GQCampaign = loadable(() => import(/* webpackChunkName: "GQCampaign" */ './index'), {
  fallback: Loading
});

GQCampaign.needs = async (props, { dispatch, getState }) => {
  const category = props.params.category;
  const params = category ? `?limit=10&category=${category}` : `?limit=10`;
  const recommendations = dispatch(fetchAdvertiseRecommendations(params));
  const displayCategory = dispatch(fetchCategoryFromKey(category));
  const state: State = getState();
  const query = state.router.location.search;
  const postcode = dispatch(fetchLocationToPostcode(query));
  const modalQuestions = dispatch(fetchModalQuestions(category));
  return Promise.all([recommendations, postcode, displayCategory, modalQuestions]);
};

export default GQCampaign;
